import Vue from 'vue'
export const EventBus = new Vue()
class TmpStore {
  self = null
  // 当前的数据字典
  propsMap = {
    target: {},
    editorIndex: null,
    components: []
  }
  static create () {
    if (!this.self || !window.Tmp_Store) {
      this.self = new TmpStore()
      window.Tmp_Store = this.self
    }
    return this.self || window.Tmp_Store
  }
  constructor () {
    this.init()
  }
  unconstructor (){
    // window.Tmp_Store = null
    this.init()
    console.log('TmpStore-unconstructor',this.self)
  }
  init (pedestalId) {    
    const pedestalConfig = pedestalId ? this.getVal(pedestalId) : null
    this.propsMap = {}
    if (pedestalConfig) this.setVal(pedestalId, pedestalConfig)
  }
  setVal (key, val) {
    console.log('this.propsMap[key]change',key, val, this)
    this.propsMap[key] = val
  }
  getVal (key) {
    return this.propsMap[key]
  }
  delVal (key) {
    delete this.propsMap[key]
  }
  $on (key, handle) {
    // this.$onMap[key] = handle
    EventBus.$on(key, handle)
  }
  $off (key, callback) {
    EventBus.$off(key)
    if (typeof handle == 'function') callback()
  }
  $emit (key, data) {
    // console.log('this.TmpStore.$emit:key, data',key, data)
    EventBus.$emit(key, data)
  }
}
function getTmpStore () {
  return TmpStore.create()
}
export default getTmpStore()
